import CompanyType from "@SearchResults/types/company/Company.type";
import addOrRemoveObjectToArray from "@Array/addOrRemoveObjectToArray";

export default function addOrRemoveCompanyFromFilteredList(carriers: CompanyType[], carrier: CompanyType) {
    return addOrRemoveObjectToArray(carriers, carrier, 'id');
}